import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const BarcodeScanningUseCase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <div className="relative bg-[#0077bb] py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative z-10 text-center md:text-left md:flex md:items-center md:justify-between">
              <div className="md:w-1/2">
                <h1 className="text-4xl font-bold text-white mb-6">
                  Streamline Data Entry with Barcode Scanning
                </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Transform your inventory management and data collection processes with our powerful barcode scanning solution.
                </p>
                <button className="bg-white text-[#0077bb] px-8 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors">
                  Get Started
                </button>
              </div>
              <div className="hidden md:block md:w-1/2">
                <img
                  src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d"
                  alt="Barcode Scanning"
                  className="rounded-lg shadow-xl"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <section className="py-20">
            <h2 className="text-3xl font-bold text-center mb-12">
              Key Features
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Real-time Scanning</h3>
                <p className="text-gray-600">
                  Instantly capture and process barcode data using your device's camera or dedicated scanner.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Multiple Format Support</h3>
                <p className="text-gray-600">
                  Support for 1D and 2D barcodes including QR codes, UPC, EAN, and more.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Automated Data Entry</h3>
                <p className="text-gray-600">
                  Eliminate manual data entry errors and save time with automated scanning.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div className="w-full bg-gray-50">
        <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">
            Common Use Cases
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-4">Inventory Management</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Track stock levels in real-time</li>
                <li>Streamline receiving and shipping processes</li>
                <li>Automate inventory counts</li>
                <li>Reduce human error in data entry</li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-4">Asset Tracking</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Monitor equipment location and status</li>
                <li>Manage maintenance schedules</li>
                <li>Track asset assignments</li>
                <li>Generate detailed asset reports</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <section className="py-20">
            <div className="text-center">
              <h2 className="text-3xl font-bold mb-6">
                Ready to Transform Your Operations?
              </h2>
              <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                Join thousands of businesses that have streamlined their operations with our barcode scanning solution.
              </p>
              <div className="space-x-4">
                <Link to="/request-demo">
                  <Button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                    Request Demo
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button variant="outline" className="border border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
                    Contact Sales
                  </Button>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BarcodeScanningUseCase;
